import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Category } from '../models/category';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Category>;
  private item: Observable<Category>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Category>('sbccv_categories', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Category>('sbccv_categories/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Category) {
    delete entity.id;
    return this.db.collection('sbccv_categories').add(Object.assign({}, entity));
  }

  update(entity: Category) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_categories').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_categories').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }

}
